<template>
  <div
    :class="
      `stop-card ` + modifier + (letterbox ? ' stop-card--letterbox' : '')
    "
  >
    <img class="stop-card__thumb" :src="image" />

    <div :class="`stop-card__meta`">
      <div class="stop-card__number">{{ stopNumber }}</div>
      <div class="stop-card__title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "StopCard",
  props: {
    image: String,
    title: String,
    stopNumber: String,
    modifier: String,
    letterbox: Boolean
  },
  computed: {
    ...mapState(["currentLang"])
  }
};
</script>

<style lang="scss" scoped>
.stop-card {
  display: flex;
  flex-direction: column;
  margin-bottom: calc(1em - 5px);
  margin-top: 5px;
  box-shadow: 0 2px 6px 0 rgba(170, 170, 170, 0.5);
}
.stop-card__thumb {
  width: 500px;
  max-width: 100%;
  height: 300px;
  object-fit: contain;
  justify-self: center;

  // @media screen and (max-height: 700px) {
  //   .stop-card--letterbox & {
  //     height: 320px;
  //     // padding-left: 50px;
  //     // padding-right: 50px;
  //   }
  // }
}

.stop-card__meta {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 1em;
  color: black;
  @include ngv-type($standard-heading, 16px, 18px);
  font-weight: normal;
}
.stop-card__number {
  padding-right: 10px;
  @include ngv-type($standard-heading, 16px, 18px);
  font-weight: normal;

  .stop-card--single & {
    padding-right: 10px;
    @include ngv-type($standard-heading, 35px, 40px);
    font-weight: normal;
  }
}
// .stop-card__title {
//   max-width: 149px;
// }
</style>
